// extracted by mini-css-extract-plugin
export default {"accountsForm":"AccountsForm_accountsForm__uI8fU"};